<template>
    <compensation-provider v-slot="{
        campaign,
        proposal,
        affiliateLink,
        discountCodes,
        proposalStep,
        patchProposalStep,
        goNextStep,
        goPreviousStep,
        isLoading,
        isPatchingProposal,
        isCompletingProposal,
        errors
    }" style="height: 100%">
        <proposal-compensation-view
            :campaign="campaign"
            :proposal-step="proposalStep"
            :proposal="proposal"
            :affiliate-link="affiliateLink"
            :discount-codes="discountCodes"
            :is-loading="isLoading"
            :is-completing-proposal="isCompletingProposal"
            :errors="errors"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchProposalStep"
        />
    </compensation-provider>
</template>
<script>
    import CompensationProvider from "../providers/proposal-steps/CompensationProvider";
    import ProposalCompensationView from "../data-views/proposals/ProposalCompensationView";

    export default {
        name: "ProposalCompensationRouterView",
        components: {
            CompensationProvider,
            ProposalCompensationView,
        },
    }
</script>
